import {
  ADVANCED_SEARCH,
  ADVANCED_SEARCH_SUCCESS,
  ADVANCED_SEARCH_FAILURE,
  ADVANCED_SEARCH_RESET,
} from "./actionType";

// payload is the filter object (must NOT contain a top-level `id` key, otherwise
// FetchAPI would append it to the URL - see helpers/APIdata/fetchAPI.js).
export const advancedSearch = (filters) => ({
  type: ADVANCED_SEARCH,
  payload: filters,
});

export const advancedSearchSuccess = (results) => ({
  type: ADVANCED_SEARCH_SUCCESS,
  payload: results,
});

export const advancedSearchFailure = (error) => ({
  type: ADVANCED_SEARCH_FAILURE,
  payload: error,
});

export const advancedSearchReset = () => ({
  type: ADVANCED_SEARCH_RESET,
});
